module.exports = __webpack_public_path__ + "7b42b78a8db1aeb665c1cb84f95fa00c.gif";